module.exports = __webpack_public_path__ + "static/banner-kendra-mobile-881aa82e99c86097cedf80ef1cf31ddc.jpg";